"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TabControl = exports.TabControlInner = void 0;
const react_1 = __importStar(require("react"));
const Tabs_styles_1 = require("../Tabs/Tabs.styles");
const TabControlInner = ({ getTabPanelId, handleOnClick, renderAsNav = false, selected, tab, tabControlId, tabIndex, useWithDropdown = false }, tabControlRef) => {
    if (renderAsNav) {
        return (react_1.default.createElement(Tabs_styles_1.TabControlLink, { href: tab.href, id: tabControlId, onClick: handleOnClick(tab), ref: tabControlRef, selected: selected, useWithDropdown: useWithDropdown }, tab.label));
    }
    const tabPanelId = getTabPanelId ? getTabPanelId(tab.id) : undefined;
    return (react_1.default.createElement(Tabs_styles_1.TabControlButton, { "aria-controls": tabPanelId, "aria-selected": selected, "data-target": tab.targetId, id: tabControlId, onClick: handleOnClick(tab), ref: tabControlRef, role: "tab", type: "button", tabIndex: tabIndex, useWithDropdown: useWithDropdown }, tab.label));
};
exports.TabControlInner = TabControlInner;
exports.TabControl = (0, react_1.forwardRef)(exports.TabControlInner);
//# sourceMappingURL=TabControl.js.map